import {AppConfigService} from '../../../config/app-config.service';
import {SearchService} from '../../search.service';
import {RichSearchList} from '../rich-search-list';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {HtmlUtilsService} from "../../../html-utils/html-utils.service";
import {OnDestroy, OnInit} from "@angular/core";
import {SearchRequest} from '../../search-request.model';
import {UserCollectionDtoInterface} from '../../../auth/account/user-collections/dto/user-collection-dto';
import {UserCollectionsService} from '../../../auth/account/user-collections/user-collections.service';
import {AuthService} from '../../../auth/auth.service';
import {AppUtils} from '../../../shared/app-utils';
import {FiltersService} from '../filters/filters.service';
import {TranslateService} from '../../../shared/translate.service';
import {Subscription} from "rxjs";
import {UserQueryDtoInterface} from '../../../auth/account/user-queries/dto/user-query-dto';
import {UserQueriesService} from '../../../auth/account/user-queries/user-queries.service';
import {UserCollectionComponent} from '../../../auth/account/user-collections/user-collection/user-collection.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../messages/message.service';
import {UserItemDeletePromptComponent} from '../../../auth/account/user-item-delete-prompt/user-item-delete-prompt.component';

export abstract class AbstractSearchListComponent implements OnInit, OnDestroy{

  queryId: string;
  searchResult: any;
  inProgress = true;
  collectionMode = false;
  private searchInTextSubscription: Subscription;
  public filtersInit = false;
  public searchInText: boolean;
  public userCollection: UserCollectionDtoInterface;
  public userQuery: UserQueryDtoInterface;

  protected constructor(protected route: ActivatedRoute,
                        protected searchService: SearchService,
                        protected appConfigService: AppConfigService,
                        protected htmlUtils: HtmlUtilsService,
                        protected userCollectionsService: UserCollectionsService,
                        protected userQueriesService: UserQueriesService,
                        protected authService: AuthService,
                        protected filterService: FiltersService,
                        protected translateService: TranslateService,
                        protected modalService: NgbModal,
                        protected messageService: MessageService,
                        protected router: Router) {
    this.searchResult = new RichSearchList('', {}, appConfigService.maxResultWindow);
  }

  ngOnInit(): void {
    this.searchInText = this.route.snapshot.queryParamMap.get('searchInText') === 'true';
    this.queryId = this.route.snapshot.queryParamMap.get('queryId');
    this.searchInTextSubscription = this.htmlUtils.searchInTextEmitter.subscribe((value) => {
      this.searchInText = value;
    })
  }

  ngOnDestroy(): void {
    this.searchInTextSubscription.unsubscribe();
  }



  public formatDate(date: number){
    return AppUtils.formatDate(date);
  }

  async find(phrase: string, page: number, pageSize: number, sortField: string, filter?: string,
       textOnly?: boolean, collectionId?: string, queryId?: string) {
    this.userCollection = null;
    this.collectionMode = false;
    let blockSearch = false;

    const logged = await this.authService.isLogged;

    const searchRequest = new SearchRequest({phrase, page: page - 1, pageSize, sort: sortField, filter, textOnly});
    this.queryId = queryId;
    if (collectionId && logged){
      const token = await this.authService.getToken();
      try {
        this.userCollection = await this.userCollectionsService.find(collectionId, token).toPromise();
      } catch (e) {
        console.warn('Error while resolving user collections: ' + e);
        this.userCollection = undefined;
      }
      this.userCollectionsService.lastUserCollection = this.userCollection;
      if (this.userCollection){
        this.collectionMode = true;
        try {
          searchRequest.ids = await this.userCollectionsService.findUserCollectionItemsIds(collectionId, token).toPromise();
        } catch (e) {
          console.warn('Error while resolving collection IDs: ' + e);
          searchRequest.ids = [];
        }
        if (searchRequest.ids.length==0){
          blockSearch = true;
        }
      }
    }else if (queryId && logged){
      const token = await this.authService.getToken();
      if(!(queryId && this.userQuery && this.userQuery.id === +queryId)){
        this.userQuery = await this.userQueriesService.find(queryId,token).toPromise();
      }
    }
    if (!blockSearch){
      this.searchService.findAll(searchRequest).subscribe(searchResult => {
        this.searchResult = searchResult;
        this.inProgress = false;
      });
    }else{
      this.filterService.allRegularFacets.next([]);
      this.searchResult = new RichSearchList('',{totalHits:0},0);
      this.inProgress = false;
    }
  }

  search(params: ParamMap) {
    this.inProgress = true;

    let paramObject = SearchService.prepareParamsObject(params, this.appConfigService);

    this.searchService.markAsSearchInText(this.searchInText);
    this.find(paramObject.phrase, paramObject.page, paramObject.pageSize, paramObject.sort, params.get('filters'), this.searchInText);
  }

  goBackLabel() {
    return this.translateService.translate('UserCollection.goBack.longLabel');
  }

  openEditModal(element: UserCollectionDtoInterface){
    const modal = this.modalService.open(UserCollectionComponent);
    modal.componentInstance.userCollectionDto = element;
    modal.result.then(value => {
      if (value) {
        this.authService.getToken().then(token => {
          this.userCollectionsService.handleSaveUserCollection(value, token, this.messageService).then(userCollectionDto => {
            if (userCollectionDto) {
              element.name = userCollectionDto.name;
              element.description = userCollectionDto.description;
              element.itemsCount = userCollectionDto.itemsCount;
            }
          });
        });
      }
    });
  }

  openDeleteModal(element: any) {
    const modalInstance = this.modalService.open(UserItemDeletePromptComponent);
    modalInstance.componentInstance.windowTitle = 'UserCollection.delete';
    modalInstance.componentInstance.itemTitle = element.name;
    if (!modalInstance.componentInstance.itemTitle){
      modalInstance.componentInstance.itemTitle = element.title;
    }
    modalInstance.result.then(result => {
      if (result) {
        this.authService.getToken().then(token => {
          this.userCollectionsService.delete(element.id, token).subscribe(result => {
            if (result) {
              this.messageService
                .successMessage( 'UserCollection.deleteResult.title', 'UserCollection.deleteResult.desc');
              this.router.navigate(['/collections']);
            } else {
              this.messageService
                .errorMessage( 'UserCollection.deleteResult.title.fail', 'UserCollection.deleteResult.desc.fail');
            }
          }, error1 => {
            console.log(error1);
            this.messageService
              .errorMessage( 'UserCollection.deleteResult.title.fail', 'UserCollection.deleteResult.desc.fail');
          });
        });
      }
    });
  }


}
